// The max upload size is 10MiB - or the value specified through an ENV var
const MAX_UPLOAD_SIZE = import.meta.env.VITE_MAX_UPLOAD_SIZE || 10485760;

/* 
TODO:
* Don't use alerts
* Make text configurable
* Maybe resize image ourselves if the image is too large?
* 
*/

export default function pictureForm(
  showQuestions = false,
  inspirationImageID = null,
) {
  return {
    inspirationImageID,
    showQuestions,

    init() {
      this.reader = new FileReader();
      this.reader.onload = () =>
        (this.$refs.imagePreview.src = this.reader.result);

      this.$watch("inspirationImageID", (value) => {
        if (value) {
          const preview = this.$root.querySelector(
            `[data-inspiration-image-preview="${value}"]`,
          );
          this.$refs.imagePreview.src = preview.src;
          this.$refs.inspirationOverlay.open = false;
          this.$refs.imageInput.files = null;
          this.showQuestions = true;
        }
      });
    },

    handleImageInput() {
      const file = this.$refs.imageInput.files[0];
      if (file.size > MAX_UPLOAD_SIZE) {
        alert("This file is too large.");
      } else if (file.type === "image/svg+xml") {
        alert("SVG files are not allowed.");
      } else {
        this.reader.readAsDataURL(file);
        this.inspirationImageID = null;
        this.showQuestions = true;
      }
    },

    handleDrop(event) {
      // Ignore if dataTransfer doesn't contain exactly one item
      if (event.dataTransfer.files.length !== 1) return;

      const file = event.dataTransfer.files[0];
      // Ignore if the file isn't an image
      if (!/^image.*/.test(file.type)) return;

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      this.$refs.imageInput.files = dataTransfer.files;
      this.handleImageInput();
    },

    dropzone: {
      ["@drop.prevent"](event) {
        this.handleDrop(event);
      },
      ["@dragover.prevent"]() {
        // Just here to prevent the file from being opened
      },
    },
  };
}
